import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const studentsSlice = createSlice({
    name: 'students',
    initialState: {
        items: [],
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStateStudents: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: "",
            }
        },
        setStudents: (state, action) => {
            return {
                items: action.payload,
                item: {},
                message: "",
                error: "",
            }
        },
        setStudent: (state, action) => {
            return {
                items: [],
                item: action.payload,
                message: "",
                error: "",
            }
        },
        setStudentMessages: (state, action) => {
            return {
                items: [],
                item: {},
                message: action.payload,
                error: "",
            }
        },
        setStudentError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getStudentsThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/students`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setStudents(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setStudentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getStudentThunk = (id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/students/${id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setStudent(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setStudentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const createStudentThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.post(`/students/createStudent`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setStudentMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setStudentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const updateStudentThunk = (id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/students/updateStudent/${id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setStudentMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setStudentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const deleteStudentThunk = (id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/students/${id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setStudentMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setStudentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const deleteRelationThunk = (id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/students/relation/${id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setStudentMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setStudentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const { 
    initialStateStudents,
    setStudents,
    setStudent,
    setStudentMessages,
    setStudentError,
 } = studentsSlice.actions;

export default studentsSlice.reducer;